import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { z } from "zod/v4";

function minMaxPrice(price: any, minPrice: any, maxPrice: any) {
  const minMaxPrice = price < minPrice || price > maxPrice;
  return minMaxPrice;
}

function isNoActiveInsuranceAndNonClient(
  ccoIsInsurance: any,
  isFormBookingClient: boolean
) {
  return !isFormBookingClient;
}

export type SchemaGoodsPriceType =
  | "retail"
  | "client"
  | "shipment_ca"
  | "shipment_corporate";
export function getMinMaxGoodsPriceFromFlag(
  type: SchemaGoodsPriceType
): { min: number; max: number } {
  const config = FlagsPermissionBookingV3.config_min_max_goods_price.getValue();
  const range = config[type] ?? config.retail;
  return { min: range.min, max: range.max };
}

const nonEmptyPriceSchema = z
  .string()
  .nonempty("bookingV3.shipment.itemPrice.error.mandatory")
  .refine(
    (val) => {
      const num = Number(val.replace(/\./g, "").replace(",", "."));
      return num > 0;
    },
    {
      message: "bookingV3.shipment.itemPrice.error.mandatory"
    }
  );

export const estimationPriceSchema = z
  .object({
    estimationPrice: nonEmptyPriceSchema,
    minEstimationPrice: z.number(),
    maxEstimationPrice: z.number(),
    productName: z.string(),
    listCodActive: z.any(),
    listDfodActive: z.any(),
    deliveryFeeType: z.string(),
    isFormBookClient: z.boolean()
  })
  .refine(
    (data) => {
      if (
        data.deliveryFeeType === "cod" &&
        isNoActiveInsuranceAndNonClient(
          data.listCodActive.ccoIsInsurance,
          data.isFormBookClient
        )
      ) {
        return !minMaxPrice(
          data.estimationPrice,
          data.listCodActive.ccoMinPrice,
          data.listCodActive.ccoMaxPrice
        );
      }
      return true;
    },
    {
      error: "errorCod"
    }
  )
  .refine(
    (data) => {
      if (
        data.deliveryFeeType === "dfod" &&
        isNoActiveInsuranceAndNonClient(
          data.listDfodActive.ccoIsInsurance,
          data.isFormBookClient
        )
      ) {
        return !minMaxPrice(
          data.estimationPrice,
          data.listDfodActive.ccoMinPrice,
          data.listDfodActive.ccoMaxPrice
        );
      }
      return true;
    },
    {
      error: "errorDfod"
    }
  )
  .refine(
    (data) =>
      !(
        data.productName.includes("OTOPACK") &&
        Number(data.estimationPrice) < 5000000
      ),
    {
      error: "bookingV3.shipment.itemPrice.error.ottopack"
    }
  )
  .refine(
    (data) => {
      return Number(data.estimationPrice) >= data.minEstimationPrice;
    },
    {
      error: "minEstimationPrice"
    }
  )
  .refine(
    (data) => {
      return Number(data.estimationPrice) <= data.maxEstimationPrice;
    },
    {
      error: "maxEstimationPrice"
    }
  );
